import { registerHandler } from '../paymentHandlerRegistry';

/**
 * Default transfer handler.
 * Fallback handler for transfer payments when no provider-specific handler matches.
 * Submits the standard transfer form via redux-form.
 */
registerHandler('transfer', {
  execute: async ({ onSubmitForm }) => {
    onSubmitForm('transfer');
  },
});
